import { fromJS } from 'immutable'

export const advisingState = fromJS({
  student_id: null,
  student_name: '',
  sex: '',
  course_code: '',
  level: null,
  college_code: '',
  scholarship_code: '',
  is_registered: false,
  has_applied: false,
  semcamp_open: false,
  sy: '',
  sem: '',
})

export const offeringState = fromJS([])
export const enrolledState = fromJS([])

const initialState = fromJS({
  advisingHasFetched: false,
  offeringsHasFetched: false,
  offeringsRaw: [],
  subjectsHasFetched: false,
  pending: false,
})

export default function enrolment(state = initialState, action) {
  switch (action.type) {
    case 'ENROL_REQ':
      return state.set('pending', true)

    case 'ENROL_ADV_SUCC':
      return state
        .set('pending', false)
        .set('advisingHasFetched', true)

    case 'ENROL_OFF_SUCC':
      return state
        .set('pending', false)
        .set('offeringsHasFetched', true)
        .set('offeringsRaw', fromJS(action.payload))

    case 'ENROL_SUB_SUCC':
      return state
        .set('pending', false)
        .set('subjectsHasFetched', true)

    case 'NOTIF_FAIL':
    case 'NOTIF_SUCC':
    case 'ENROL_ADDSUB_SUCC':
    case 'ENROL_DELSUB_SUCC':
    case 'ENROL_CANCEL_SUCC':
    case 'ENROL_WITH_SUCC':
      return state.set('pending', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Enrolment/reducer.js